/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-08 00:00:00
 *
 *******************************************************/
import _ from 'lodash';

import React, { Component } from 'react';
import { Modal, Card, TextStyle, TextField, Button } from '@shopify/polaris';
import { DuplicateMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import {
  navigateToShopifyCustomizeSSR,
  copyClipBoard
} from 'src/helpers/shopify-integration-helpers';

type Props = {};
type ComposedProps = Props & WithI18nProps;

type State = {};

class TemplateChangedModal extends Component<ComposedProps, State> {
  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  render() {
    const { i18n, open, onClose, selectedTheme = {}, integratedTemplateInstance = {} } = this.props;
    const { templateId, templateName } = integratedTemplateInstance;
    const themeId = _.get(selectedTheme, 'id', '');

    return (
      <div>
        <Modal
          open={open}
          onClose={onClose}
          title={i18n.translate('AdminHTML.ShopifyIntegration.TemplateChangedModal.title')}
          primaryAction={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.goToBoostSnippet'),
              onAction: () => {
                navigateToShopifyCustomizeSSR(themeId);
              }
            }
          ]}
          secondaryActions={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.close'),
              onAction: this.props.onClose
            }
          ]}>
          {/* Content */}
          <div className="template-changed-modal">
            <Card>
              <Card.Section>
                <div className="content">
                  {i18n.translate('AdminHTML.ShopifyIntegration.TemplateChangedModal.content1', {
                    t1: <TextStyle variation="strong">{templateName}</TextStyle>
                  })}
                </div>
                <div className="content">
                  {i18n.translate('AdminHTML.ShopifyIntegration.TemplateChangedModal.content2', {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.ShopifyIntegration.TemplateChangedModal.content2_t1'
                        )}
                      </TextStyle>
                    ),
                    t2: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.ShopifyIntegration.TemplateChangedModal.content2_t2'
                        )}
                      </TextStyle>
                    ),
                    t3: <TextStyle variation="strong">{templateName}</TextStyle>
                  })}
                </div>
                <p style={{ paddingTop: '2px', paddingBottom: '4px' }}>Template ID</p>
                <div>
                  <TextField
                    value={templateId}
                    disabled={true}
                    suffix={
                      <span className="copy">
                        <Button
                          icon={DuplicateMinor}
                          plain
                          onClick={() => copyClipBoard(i18n, templateId)}
                        />
                      </span>
                    }
                  />
                </div>
              </Card.Section>
            </Card>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withI18n()(TemplateChangedModal);
